import { createAction, props } from '@ngrx/store';
import { AcceptanceIdentifier, MetadataConfiguration } from '../../models/acceptance-identifier.model';

export const getMetadataConfiguration = createAction(
    '[Metadata Configuration] Get Metadata Configuration',
    props<{
        documentTypeId: number;
    }>()
);

export const getMetadataConfigurationSuccess = createAction(
    '[Metadata Configuration] Get Metadata Configuration Success',
    props<{ metadataConfiguration: MetadataConfiguration }>()
);

export const getMetadataConfigurationFailure = createAction(
    '[Metadata Configuration] Get Metadata Configuration Failure',
    props<{ error: unknown }>()
);

export const addAcceptanceIdentifier = createAction(
    '[Metadata Configuration] Add Acceptance Identifier',
    props<{ acceptanceIdentifier: AcceptanceIdentifier }>()
);

export const updateAcceptanceIdentifier = createAction(
    '[Metadata Configuration] Update Acceptance Identifier',
    props<{ acceptanceIdentifier: AcceptanceIdentifier }>()
);

export const sortAcceptanceIdentifiers = createAction(
    '[Metadata Configuration] Sort Acceptance Identifiers',
    props<{ acceptanceIdentifiers: AcceptanceIdentifier[] }>()
);

export const resetMetadataConfiguration = createAction('[Metadata Configuration] Reset Metadata Configuration');
